import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {recordEmojiUseAction} from '../../../../store/data/localPreferences/localPreferencesActions';
import {getEmojiSearcher, SearchEmojiDefinition} from '../../../../store/stateless/emojiSelectors';
import {EmojiEditorDropdownContent} from './emojiEditorDropdownContent';

/*
 * Props.
 */

interface EmojiEditorDropdownContentContainerProps {
  onEmojiSelect: (partialShortcode: string, shortcode: string) => void;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<EmojiEditorDropdownContentContainerProps>()(() => ({
  emojiSearcher: getEmojiSearcher,
}));

export const EmojiEditorDropdownContentContainer = connect(
  mapStateToProps,
  {recordEmojiUse: recordEmojiUseAction},
  (stateProps, dispatchProps, ownProps) => {
    const onEmojiSelect = (partialShortcode: string, searchEmoji: SearchEmojiDefinition) => {
      dispatchProps.recordEmojiUse(searchEmoji.emoji);
      ownProps.onEmojiSelect(partialShortcode, searchEmoji.fullShortcode);
    };

    return {
      ...ownProps,
      ...stateProps,
      onEmojiSelect,
    };
  },
)(EmojiEditorDropdownContent);
